import { useQuery } from '@tanstack/react-query';
import { officeApiClient } from 'src/api/FiretrolApiClientInstances';
import { queryKeys } from 'src/api/queries/queryKeys';
import { toCancelToken } from 'src/api/queries/queryClient';

export function useOfficeDetail(id: number | null | undefined) {
  return useQuery({
    queryKey: queryKeys.organization.officeDetail(id ?? -1),
    queryFn: ({ signal }) => officeApiClient.get(id!, toCancelToken(signal)),
    enabled: id != null && id > 0,
    staleTime: 0,
    meta: { errorContext: 'office detail' },
  });
}
